import { render, staticRenderFns } from "./DomainSettingsPage.vue?vue&type=template&id=3f4ceb3c&scoped=true"
import script from "./DomainSettingsPage.vue?vue&type=script&lang=js"
export * from "./DomainSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./DomainSettingsPage.vue?vue&type=style&index=0&id=3f4ceb3c&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4ceb3c",
  null
  
)

export default component.exports